import React, { Component } from 'react'
import styles from "./FloatText.module.css"

import { EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const TOOL_TOP_LIMIT = 37
export default class FloatText extends Component {
    constructor(props) {
        super(props)
        this.state = {
            top: 60,
            left: 0,
            toolOffsetTop: 0,
            toolOffsetLeft: 0,
            alpha: (this.props.alpha) ? this.props.alpha : 1,
            backgroundColor: (this.props.color) ? this.props.color : "rgba(15,133,66,0.5)",
            editorState: (this.props.state && this.props.state.editorState) ? this.props.state.editorState : EditorState.createEmpty(),
            enableTool: (this.props.state && this.props.state.enableTool != undefined) ? this.props.state.enableTool : false,
            visible: "hidden",
        };

        this.objInfo = {
            moveFlag: false,
            originalTop: 0,
            originalLeft: 0,
        }

        this.node = null
    }

    disableVisibleHandler = () => {
        this.objInfo.moveFlag = false
        this.setState(state => { return { visible: "hidden", enableTool: false } })
    }
    enableVisible = () => {
        this.setState(state => { return { visible: "visible", enableTool: true } })
    }
    selectHandler = (e) => {
        if (this.props.selectCallback)
            this.props.selectCallback(this.props.id)
    }
    deleteHandler = (e) => {
        if (this.props.deleteCallback)
            this.props.deleteCallback(this.props.id)
    }
    moveEnableTrigger = (e) => {
        this.objInfo.moveFlag = true
        this.objInfo.originalTop = e.pageY - this.state.top
        this.objInfo.originalLeft = e.pageX - this.state.left
    }
    moveDisableTrigger = (e) => {
        this.objInfo.moveFlag = false
    }
    moveHandler = (e) => {
        if (this.objInfo.moveFlag) {
            const mx = e.pageX
            const my = e.pageY
            const diffX = mx - this.objInfo.originalLeft
            const diffY = my - this.objInfo.originalTop
            this.setState(state => { return { top: diffY, left: diffX } })
        }
    }

    mergeColorWithAlpha = (color, alpha) => {
        const r = parseInt(color.substr(1, 2), 16)
        const g = parseInt(color.substr(3, 2), 16)
        const b = parseInt(color.substr(5, 2), 16)
        const a = alpha

        return `rgba(${r},${g},${b},${a})`
    }
    //state handler
    onEditorStateChange = (editorState) => {
        // console.log(editorState)
        if (this.props.updateStateCB)
            this.props.updateStateCB(this.state)
        this.setState(state => { return { editorState: editorState } })
    }

    componentDidMount() {
        document.addEventListener("mousemove", (e) => {
            this.moveHandler(e)
        })
        document.addEventListener("scroll", (e) => {
            if (this.node) {
                const offsetTop = this.node.parentNode.getBoundingClientRect().top
                const offsetLeft = this.node.parentNode.getBoundingClientRect().left

                const estimateOffsetTop = -offsetTop + TOOL_TOP_LIMIT
                this.setState(state => {
                    if (estimateOffsetTop > 0) {
                        return { toolOffsetTop: estimateOffsetTop }
                    } else {
                        return { toolOffsetTop: 0 }
                    }
                })
            }
        })
    }
    render() {
        const { editorState } = this.state;

        const toolbarStyle = {
            position: "absolute",
            top: `${(-this.state.top + this.state.toolOffsetTop)}px`,
            left: `${(-this.state.left + this.state.toolOffsetLeft)}px`,
            width: "520px",
            color: "black",
            display: (this.state.enableTool) ? "" : "none",
        }

        const editorStyle = {
            position: "relative",
            overflowX: "hidden",
            minWidth: "4rem",
            color: "black",
            zIndex: 100
        }
        const style = {
            top: `${this.state.top}px`,
            left: `${this.state.left}px`,
            backgroundColor: (this.props.color) ? this.mergeColorWithAlpha(this.props.color, this.props.alpha) : "rgba(15,133,66,0.5)",
        }
        const visibleStyle = { visibility: this.state.visible }
        return (
            <div id={this.props.id} key={this.props.id} className={styles.container} style={style}
                onClick={this.selectHandler}
                ref={ref => { this.node = ref }}>
                <Editor
                    onFocus={this.enableVisible}
                    onBlur={this.disableVisibleHandler}
                    editorStyle={editorStyle}
                    editorState={editorState}
                    onEditorStateChange={this.onEditorStateChange}
                    toolbarStyle={toolbarStyle}
                    toolbar={{
                        options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker'],
                        inline: { inDropdown: true },
                        list: { inDropdown: true },
                        textAlign: { inDropdown: true },
                        link: { inDropdown: true },
                        history: { inDropdown: true }
                    }}
                />

                <div className={styles.moveStyle}
                    style={visibleStyle}
                    onMouseDown={this.moveEnableTrigger}
                    onMouseUp={this.moveDisableTrigger}>
                    <div className={styles.moveContentStyle} onMouseDown={(e) => { e.preventDefault() }}></div>
                </div>
                <div className={styles.deleteStyle}
                    style={visibleStyle}
                    onClick={this.deleteHandler}>
                    X
                </div>
            </div>
        )
    }
}
